













import { Component, Mixins, Emit } from "vue-property-decorator";
import MultiOptionListBoxSelector from "../../system/selectors/MultiOptionListBoxSelector.vue";
import { DepartmentSelectableMixin } from "./mixins";

@Component({
  components: {
    MultiOptionListBoxSelector,
  },
})
export default class MultiDepartmentListSelector extends Mixins(DepartmentSelectableMixin) {
  @Emit()
  dblclick(e: PointerEvent): void {}
}
